import Backdrop from '@mui/material/Backdrop'
import React, { useContext } from 'react'
import MailIcon from '../../../assets/mail.svg'
import { AppStateContext } from '../../../state/AppProvider'
import styles from './AccessRestrictedModal.module.css'
interface AccessRestrictedModalProps {
  open: boolean
  onContactSupport?: () => void
}

const AccessRestrictedModal: React.FC<AccessRestrictedModalProps> = ({ open }) => {
  const appStateContext = useContext(AppStateContext)
  const support = appStateContext?.state.frontendSettings?.support
  const canShowSupport = support?.email && support?.name

  return (
    <Backdrop
      open={open}
      className={styles.backdrop}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true">
        <h2 className={styles.title}>Access Restricted</h2>
        <p className={styles.message}>
          You do not have access to this platform at this time. If you believe this is an error or need access, please
          contact the support representative.
        </p>
        {canShowSupport && (
          <p className={styles.support}>
            <span className={styles.supportName}>{support?.name}</span>
            <span className={styles.supportEmail}>
              <img
                src={MailIcon}
                alt="Email"
              />
              {support?.email}
            </span>
          </p>
        )}
      </div>
    </Backdrop>
  )
}

export default AccessRestrictedModal
